/**
 * O marcador que a moldura do thread põe na RAIZ de todo cartão.
 *
 * ★ Por que existe como constante, e não como string em cada template: o
 * `data-teste="parte-do-turno"` não é enfeite de teste — é o contrato pelo qual
 * o thread se deixa inspecionar. O E2E do contrato de UI ([T023] da spec-001)
 * varre exatamente este seletor para saber o que montou; um cartão sem o
 * marcador está na tela e invisível para a guarda, que é o pior dos dois
 * mundos: o vermelho não aparece e a cobertura some sem ninguém notar.
 *
 * Foi o que aconteceu com os três donos LEGADOS do thread — o painel de
 * deliberação (dentro do `assistant-blocks`), os serviços citados e as
 * perguntas ao gestor. Eles renderizam por caminho próprio, sem passar pelo
 * `partes-do-turno.vue`, e por isso não herdavam o marcador.
 *
 * Espalhar por `v-bind` também garante que o dia em que a moldura ganhar um
 * segundo atributo, os cinco sítios o recebem de uma vez.
 */
export const MOLDURA_DO_THREAD = { 'data-teste': 'parte-do-turno' }

/** O valor do marcador, para quem precisa só da string (seletores, guardas). */
export const MARCADOR_DE_PARTE = MOLDURA_DO_THREAD['data-teste']
